import { useState } from "react"

import { Themeable } from "@/app/types"
import { toggleState } from "@/utils/common"

import PasswordFieldView from "./PasswordFieldView"

interface NewPasswordFieldsProps extends Themeable {
  password: string
  confirmPassword: string
  passwordCustomValidity?: string
  confirmPasswordCustomValidity?: string
  onPasswordChange?(password: string): void
  onConfirmPasswordChange?(confirmPassword: string): void
}

function NewPasswordFields(props: NewPasswordFieldsProps) {
  const [firstPasswordHidden, setFirstPasswordHidden] = useState(true)
  const [secondPasswordHidden, setSecondPasswordHidden] = useState(true)

  return (
    <div className="new-password-fields">
      <PasswordFieldView
        theme={props.theme}
        name={props.password}
        autoComplete="new-password"
        placeholder="Enter new password"
        customValidity={props.passwordCustomValidity}
        hidden={firstPasswordHidden}
        onHiddenToggle={toggleState(setFirstPasswordHidden)}
      />

      <PasswordFieldView
        theme={props.theme}
        name={props.confirmPassword}
        autoComplete="new-password"
        placeholder="Confirm your password"
        customValidity={
          props.confirmPasswordCustomValidity
        }
        hidden={secondPasswordHidden}
        onHiddenToggle={toggleState(setSecondPasswordHidden)}
      />
    </div>
  )
}

export default NewPasswordFields
